export default "__VITE_ASSET__9fd4373a__"